import React, { Fragment } from "react";

function SelectElement(props) {
  return (
    <Fragment>
      <div className={props.mb4}>
        <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
          {props.labelText}
          {props.tooltipText && (
            <span className="tooltip">
              <i className="fa-regular fa-circle-question fa-fw"></i>
              <span className="tooltiptext">{props.tooltipText}</span>
            </span>
          )}
        </label>
        <select
          className={props.selectClassName}
          id={props.selectID}
          disabled={props.disabled}
          value={props.value}
          placeholdertext={props.placeholderText} // Add Arabic placeholder
          onChange={(e) =>
            props.payment == "1"
              ? props.onChange(
                  props.parentCompenent,
                  props.compenent,
                  e.target.options[e.target.selectedIndex].text,
                  e.target.value,
                  props.index,
                  props.buildingIndex,
                )
              : props.onChange(
                  props.parentCompenent,
                  props.compenent,
                  props.name,
                  e.target.value,
                  props.index,
                  props.buildingIndex,
                  props.floorIndex,
                )
          }
        >
          {/* <option
            value={
              props.disabled
                ? props.options.filter((option) => {
                    return option.key === props.value;
                  }).length
                  ? props.options.filter((option) => {
                      return option.key === props.value;
                    })[0].props["value"]
                  : ""
                : ""
            }
          >
            {props.disabled
              ? props.options.filter((option) => {
                  return option.key === props.value;
                }).length
                ? props.options.filter((option) => {
                    return option.key === props.value;
                  })[0].props["children"]
                : props.default
              : props.default}
          </option> */}
          {/* Placeholder option */}
          <option value="" disabled hidden>
            {props.placeholderText || " "}
          </option>
          {props.options}
        </select>
        {props.pText && <p className={props.pClassName}>{props.pText}</p>}
      </div>
    </Fragment>
  );
}

export default SelectElement;
